import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { Editor } from '@tinymce/tinymce-react';
import { useEffect, useRef, useState } from 'react';
import { Button, Labeled, RichTextField, TextInputProps, useResourceContext, useTranslate } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { FileManagerModal } from './FileManagerModalInput';
import { HandleSelectClick as HandleLinkSelectClick, LinkInputModal } from './LinkInput';

// import 'tinymce/tinymce';

import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
// import 'tinymce/plugins/hr';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/template';
import 'tinymce/plugins/wordcount';

// import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
// import contentCss from 'tinymce/skins/content/default/content.css';


interface TinyMCEInputProps extends TextInputProps {
  hideLabel?: boolean;
}

interface TinyMCEInputInstanceProps extends TextInputProps {
  hideLabel?: boolean;
  onHideEditor: () => void;
}

const TinyMCEInputInstance = ({ source, hideLabel, onHideEditor, ...props }: TinyMCEInputInstanceProps) => {
  const { setValue } = useFormContext();
  const editorRef = useRef<Editor>(null);
  const filePickerCallback = useRef<(url: string, meta: { title: string }) => void>();
  const linkListSuccess = useRef<(links: Array<{ title: string, value: string }>) => void>();
  const [showModeDialog, setShowModeDialog] = useState(false);
  const [showFmDialog, setShowFmDialog] = useState(false);
  const [showLinkDialog, setShowLinkDialog] = useState(false);

  const initialValue = useWatch({ name: source })
  const [editorValue, setEditorValue] = useState(initialValue ? initialValue : '');

  useEffect(() => setEditorValue(initialValue ? initialValue : ''), [initialValue]);
  useEffect(() => {
    if (false === showFmDialog) {
      filePickerCallback.current = undefined;
      linkListSuccess.current = undefined;
    }
  }, [showFmDialog])
  useEffect(() => {
    if (false === showLinkDialog) {
      filePickerCallback.current = undefined;
      linkListSuccess.current = undefined;
    }
  }, [showLinkDialog])

  const handleFmSelectClick = (selection: any) => {
    console.log('handleFmSelectClick', selection, filePickerCallback.current, linkListSuccess.current);
    setShowFmDialog(false);
    if (filePickerCallback.current) {
      filePickerCallback.current(selection[0].src, { title: '' });
    } else if (linkListSuccess.current) {
      linkListSuccess.current([{ title: selection[0].name, value: selection[0].src }]);
    }
  }

  const handleFmCloseClick = () => {
    console.log('handleFmCloseClick');
    setShowFmDialog(false)
    if (filePickerCallback.current) {
      filePickerCallback.current('', { title: '' });
    } else if (linkListSuccess.current) {
      linkListSuccess.current([]);
    }
  }

  const handleLinkSelectClick: HandleLinkSelectClick = (selection: any, lang: string, url: string) => {
    console.log('handleLinkSelectClick', selection, lang, url);
    setShowLinkDialog(false);
    if (linkListSuccess.current) {
      console.log(selection.map((item: any) => ({ title: item[`title_${lang}`], value: url })));
      linkListSuccess.current(selection.map((item: any) => ({ title: item[`title_${lang}`], value: url })));
    }
  }

  const handleLinkCloseClick = () => {
    console.log('handleLinkCloseClick');
    setShowLinkDialog(false)
    if (linkListSuccess.current) {
      linkListSuccess.current([]);
    }
  }

  const handleModeDialogCloseClick = () => {
    setShowModeDialog(false);
  }

  const file_picker_callback = (cb: any, value: any, meta: any) => {
    console.log(cb);
    filePickerCallback.current = cb;
    setShowFmDialog(true);
  }

  const link_list = (success: any) => {
    linkListSuccess.current = success;
    setShowModeDialog(true);
  }

  const myCustomURLConverter = (url: string, _node: any, _on_save: any) => {
    return url;
  }

  return (
    <>
      <Editor
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
        onInit={(evt, editor) => {
          editor.editorContainer.style.height = '500px';
          editorRef.current = editor;
          console.log(editor, source);
        }}
        initialValue={initialValue}
        value={editorValue}
        onEditorChange={(newValue, editor) => {
          console.log('onEditorChange', newValue, source);
          setEditorValue(newValue);
        }}
        init={{
          menubar: false,
          toolbar_mode: 'wrap',
          plugins: "advlist anchor autolink autoresize autosave charmap code emoticons fullscreen help image importcss link lists media preview quickbars table wordcount",
          toolbar1: "bold italic underline strikethrough subscript superscript | aligncenter alignjustify alignleft alignnone alignright | formatpainter fontfamily fontsize forecolor backcolor lineheight | table hr blockquote | hideeditor",
          toolbar2: "undo redo | anchor charmap emoticons image media link openlink unlink | bullist numlist indent outdent | paste pastetext | selectall remove removeformat | preview code fullscreen wordcount help",
          // toolbar: "aligncenter alignjustify alignleft alignnone alignright| anchor | blockquote blocks | backcolor | bold | copy | cut | fontfamily fontsize forecolor h1 h2 h3 h4 h5 h6 hr indent | italic | language | lineheight | newdocument | outdent | paste pastetext | print | redo | remove removeformat | selectall | strikethrough | styles | subscript superscript underline | undo | visualaid | a11ycheck advtablerownumbering typopgraphy anchor restoredraft casechange charmap checklist code codesample addcomment showcomments ltr rtl editimage fliph flipv imageoptions rotateleft rotateright emoticons export footnotes footnotesupdate formatpainter fullscreen help image insertdatetime link openlink unlink bullist numlist media mergetags mergetags_list nonbreaking pagebreak pageembed permanentpen preview quickimage quicklink quicktable cancel save searchreplace spellcheckdialog spellchecker | table tablecellprops tablecopyrow tablecutrow tabledelete tabledeletecol tabledeleterow tableinsertdialog tableinsertcolafter tableinsertcolbefore tableinsertrowafter tableinsertrowbefore tablemergecells tablepasterowafter tablepasterowbefore tableprops tablerowprops tablesplitcells tableclass tablecellclass tablecellvalign tablecellborderwidth tablecellborderstyle tablecaption tablecellbackgroundcolor tablecellbordercolor tablerowheader tablecolheader | tableofcontents tableofcontentsupdate | template typography | insertfile | visualblocks visualchars | wordcount",
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',

          image_advtab: true,
          file_picker_types: 'image',
          file_picker_callback: file_picker_callback,

          urlconverter_callback: myCustomURLConverter,

          default_link_target: '_blank',
          link_title: false,
          link_list: link_list,

          setup: (editor) => {
            editor.on('blur', () => {
              setValue(source, editor.getContent(), { shouldDirty: true });
            })
            editor.ui.registry.addButton('hideeditor', {
              icon: 'close',
              tooltip: 'Close Editor',
              onAction: function (_) {
                setValue(source, editor.getContent(), { shouldDirty: true });
                onHideEditor();
              }
            });
          }
        }}
      />

      <Dialog
        // maxWidth={"xl"}
        fullWidth
        open={showModeDialog}
        onClose={handleModeDialogCloseClick}
        aria-label={"Select the type of link"}
      >
        <DialogTitle>Select the type of link</DialogTitle>
        <Button onClick={() => { setShowLinkDialog(true); }} label="Link" />
        <Button onClick={() => { setShowFmDialog(true); }} label="File Manager" />
        <Button onClick={() => { setShowModeDialog(false); }} label="Others" />
        <DialogActions>
          <Button onClick={() => { setShowModeDialog(false); }} label="Close" />
        </DialogActions>
      </Dialog>

      <LinkInputModal showDialog={showLinkDialog} handleCloseClick={handleLinkCloseClick} handleSelectClick={handleLinkSelectClick} />
      <FileManagerModal showDialog={showFmDialog} handleCloseClick={handleFmCloseClick} handleSelectClick={handleFmSelectClick} />
    </>
  );
}

const TinyMCEInput = ({ label, source, hideLabel, sx, ...props }: TinyMCEInputProps) => {
  const resource = useResourceContext();
  const translate = useTranslate();

  const [showEditor, setShowEditor] = useState(false);

  return (
    <Box sx={{ ...sx, display: 'flex', }}>
      {!hideLabel
        ? <Labeled label={label ? label : translate(`resources.${resource}.fields.${source}`)} sx={{ width: '100%' }}>
          <>
            {!showEditor && <div onClick={() => setShowEditor(true)} style={{ height: '200px', maxHeight: '400px', backgroundColor: 'lightgray', padding: '10px', position: 'relative', borderRadius: '10px' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, overflowY: 'scroll', margin: '10px' }}>
                <RichTextField source={source} />
              </div>
              <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button label={translate("ra.action.html_editor")} onClick={() => setShowEditor(true)} {...props}></Button>
              </div>
            </div>}
            {showEditor && <TinyMCEInputInstance source={source} hideLabel={hideLabel} onHideEditor={() => setShowEditor(false)} {...props} />}
          </>
        </Labeled>
        : <>
          {!showEditor && <div onClick={() => setShowEditor(true)} style={{ height: '200px', maxHeight: '400px', backgroundColor: 'lightgray', padding: '10px', position: 'relative', borderRadius: '10px' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, overflowY: 'scroll', margin: '10px' }}>
              <RichTextField source={source} />
            </div>
            <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Button label={translate("ra.action.html_editor")} onClick={() => setShowEditor(true)} {...props}></Button>
            </div>
          </div>}
          {showEditor && <TinyMCEInputInstance source={source} hideLabel={hideLabel} onHideEditor={() => setShowEditor(false)} {...props} />}
        </>
      }
    </Box>
  )
}

TinyMCEInput.defaultProps = {
}

export default TinyMCEInput;
